module.exports = __webpack_public_path__ + "img/sanda.ba9ce66d.png";